<template>
  <a-tag :color="status.color">
    <template #icon>
      <clock-circle-outlined v-if="status.id === PlanStatus.ToDo" />
      <sync-outlined
        v-if="status.id === PlanStatus.InProgress"
        :spin="true" />
      <sync-outlined
        v-if="status.id === PlanStatus.AwaitingVerification"
        :spin="false" />
      <close-circle-outlined v-if="status.id === PlanStatus.Rejected" />
      <check-circle-outlined v-if="status.id === PlanStatus.Done" />
      <like-outlined v-if="status.id === PlanStatus.Approved" />
      <edit-outlined v-if="status.id === PlanStatus.OnAdjustment" />
      <pause-circle-outlined v-if="status.id === PlanStatus.OnPause" />
      <close-circle-outlined v-if="status === PlanStatus.Deactivated" />
    </template>
    {{ status.text }}
  </a-tag>
</template>

<script>
import {
  SyncOutlined,
  LikeOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  EditOutlined,
  PauseCircleOutlined,
} from '@ant-design/icons-vue';
import { PlanStatus } from '@/enums/planStatus';

export default {
  name: 'StatusTag',
  components: {
    EditOutlined,
    SyncOutlined,
    LikeOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined,
    PauseCircleOutlined,
  },
  props: {
    status: {
      default: () => {},
      type: Object,
    },
  },
  setup() {
    return {
      PlanStatus,
    };
  },
};
</script>
